import { render } from "./AddToHomeScreen.vue?vue&type=template&id=098f10e9&scoped=true"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=js"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=js"

import "./AddToHomeScreen.vue?vue&type=style&index=0&id=098f10e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098f10e9"]])

export default __exports__